import * as Dialog from '@radix-ui/react-dialog';
import { FaPlus } from 'react-icons/fa6';
import { twMerge } from 'tailwind-merge';

import { Button } from '@/components/Button';

export type CloseProps = Dialog.DialogCloseProps;

export function Close({ className, children, ...props }: CloseProps) {
  return (
    <Dialog.Close asChild {...props}>
      {children || (
        <Button
          className={twMerge(
            'absolute top-4 left-4 rounded-full',
            'bg-white',
            className,
          )}
          variant="outline"
        >
          <FaPlus className="size-4 rotate-45" />
        </Button>
      )}
    </Dialog.Close>
  );
}
